// filter: sepia(0) brightness(1) contrast(1) saturate(1) hue-rotate(360deg)

let Atmospheres = {
    "welcome": {
        "id": "welcome",
        "icon": "earth1_karaworld.png",
        "decor_tv": "earth1_karaworld.mp4",
        "decor_vp": "earth1_karaworld.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "neutral": {
        "id": "neutral",
        "icon": "earth1_icon.png",
        "decor_tv": "earth1.mp4",
        "decor_vp": "earth1.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "earth2": {
        "id": "earth2",
        "icon": "earth2_icon.png",
        "decor_tv": "earth2.mp4",
        "decor_vp": "earth2.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "american_dog": {
        "id": "american_dog",
        "icon": "american_dog_icon.png",
        "decor_tv": "american_dog.mp4",
        "decor_vp": "american_dog.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "bass": {
        "id": "bass",
        "icon": "bass_icon.png",
        "decor_tv": "bass.mp4",
        "decor_vp": "bass.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "beale_street": {
        "id": "beale_street",
        "icon": "beale_street_icon.png",
        "decor_tv": "beale_street.mp4",
        "decor_vp": "beale_street.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "blinking_neons": {
        "id": "blinking_neons",
        "icon": "blinking_neons_icon.png",
        "decor_tv": "blinking_neons.mp4",
        "decor_vp": "blinking_neons.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "blue_bubbles": {
        "id": "blue_bubbles",
        "icon": "blue_bubbles_icon.png",
        "decor_tv": "blue_bubbles.mp4",
        "decor_vp": "blue_bubbles.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "blue_glow": {
        "id": "blue_glow",
        "icon": "blue_glow_icon.png",
        "decor_tv": "blue_glow.mp4",
        "decor_vp": "blue_glow.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "bnw_vinyl": {
        "id": "bnw_vinyl",
        "icon": "bnw_vinyl_icon.png",
        "decor_tv": "bnw_vinyl.mp4",
        "decor_vp": "bnw_vinyl.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "cactus": {
        "id": "cactus",
        "icon": "cactus_icon.png",
        "decor_tv": "cactus.mp4",
        "decor_vp": "cactus.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "california_sun": {
        "id": "california_sun",
        "icon": "california_sun_icon.png",
        "decor_tv": "california_sun.mp4",
        "decor_vp": "california_sun.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "cannabis": {
        "id": "cannabis",
        "icon": "cannabis_icon.png",
        "decor_tv": "cannabis.mp4",
        "decor_vp": "cannabis.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "cassette": {
        "id": "cassette",
        "icon": "cassette_icon.png",
        "decor_tv": "cassette.mp4",
        "decor_vp": "cassette.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "cats": {
        "id": "cats",
        "icon": "cats_icon.png",
        "decor_tv": "cats.mp4",
        "decor_vp": "cats.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "christmas_candles": {
        "id": "christmas_candles",
        "icon": "christmas_candles_icon.png",
        "decor_tv": "christmas_candles.mp4",
        "decor_vp": "christmas_candles.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "christmas_fall": {
        "id": "christmas_fall",
        "icon": "christmas_fall_icon.png",
        "decor_tv": "christmas_fall.mp4",
        "decor_vp": "christmas_fall.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "city_lights": {
        "id": "city_lights",
        "icon": "city_lights_icon.png",
        "decor_tv": "city_lights.mp4",
        "decor_vp": "city_lights.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "colored_circles": {
        "id": "colored_circles",
        "icon": "colored_circles_icon.png",
        "decor_tv": "colored_circles.mp4",
        "decor_vp": "colored_circles.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "colored_star": {
        "id": "colored_star",
        "icon": "colored_star_icon.png",
        "decor_tv": "colored_star.mp4",
        "decor_vp": "colored_star.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "crowd1": {
        "id": "crowd1",
        "icon": "crowd1_icon.png",
        "decor_tv": "crowd1.mp4",
        "decor_vp": "crowd1.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "crowd2": {
        "id": "crowd2",
        "icon": "crowd2_icon.png",
        "decor_tv": "crowd2.mp4",
        "decor_vp": "crowd2.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "curtain": {
        "id": "curtain",
        "icon": "curtain_icon.png",
        "decor_tv": "curtain.mp4",
        "decor_vp": "curtain.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "disco_dog": {
        "id": "disco_dog",
        "icon": "disco_dog_icon.png",
        "decor_tv": "disco_dog.mp4",
        "decor_vp": "disco_dog.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "dj_buttons": {
        "id": "dj_buttons",
        "icon": "dj_buttons_icon.png",
        "decor_tv": "dj_buttons.mp4",
        "decor_vp": "dj_buttons.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "dj_mix": {
        "id": "dj_mix",
        "icon": "dj_mix_icon.png",
        "decor_tv": "dj_mix.mp4",
        "decor_vp": "dj_mix.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "dj_rain": {
        "id": "dj_rain",
        "icon": "dj_rain_icon.png",
        "decor_tv": "dj_rain.mp4",
        "decor_vp": "dj_rain.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "embers3": {
        "id": "embers3",
        "icon": "embers3_icon.png",
        "decor_tv": "embers3.mp4",
        "decor_vp": "embers3.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "far_west": {
        "id": "far_west",
        "icon": "far_west_icon.png",
        "decor_tv": "far_west.mp4",
        "decor_vp": "far_west.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "field": {
        "id": "field",
        "icon": "field_icon.png",
        "decor_tv": "field.mp4",
        "decor_vp": "field.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "fixed_stage_lights": {
        "id": "fixed_stage_lights",
        "icon": "fixed_stage_lights_icon.png",
        "decor_tv": "fixed_stage_lights.mp4",
        "decor_vp": "fixed_stage_lights.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "flowers": {
        "id": "flowers",
        "icon": "flowers_icon.png",
        "decor_tv": "flowers.mp4",
        "decor_vp": "flowers.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "geometric_neons": {
        "id": "geometric_neons",
        "icon": "geometric_neons_icon.png",
        "decor_tv": "geometric_neons.mp4",
        "decor_vp": "geometric_neons.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "glittering_background": {
        "id": "glittering_background",
        "icon": "glittering_background_icon.png",
        "decor_tv": "glittering_background.mp4",
        "decor_vp": "glittering_background.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "golden_circles": {
        "id": "golden_circles",
        "icon": "golden_circles_icon.png",
        "decor_tv": "golden_circles.mp4",
        "decor_vp": "golden_circles.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "golden_sparkles": {
        "id": "golden_sparkles",
        "icon": "golden_sparkles_icon.png",
        "decor_tv": "golden_sparkles.mp4",
        "decor_vp": "golden_sparkles.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "golden_star": {
        "id": "golden_star",
        "icon": "golden_star_icon.png",
        "decor_tv": "golden_star.mp4",
        "decor_vp": "golden_star.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "green_laser": {
        "id": "green_laser",
        "icon": "green_laser_icon.png",
        "decor_tv": "green_laser.mp4",
        "decor_vp": "green_laser.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "hairy_dancer": {
        "id": "hairy_dancer",
        "icon": "hairy_dancer_icon.png",
        "decor_tv": "hairy_dancer.mp4",
        "decor_vp": "hairy_dancer.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "hearts": {
        "id": "hearts",
        "icon": "hearts_icon.png",
        "decor_tv": "hearts.mp4",
        "decor_vp": "hearts.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "jazz_sign": {
        "id": "jazz_sign",
        "icon": "jazz_sign_icon.png",
        "decor_tv": "jazz_sign.mp4",
        "decor_vp": "jazz_sign.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "latino_dancer": {
        "id": "latino_dancer",
        "icon": "latino_dancer_icon.png",
        "decor_tv": "latino_dancer.mp4",
        "decor_vp": "latino_dancer.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "latino_dancers": {
        "id": "latino_dancers",
        "icon": "latino_dancers_icon.png",
        "decor_tv": "latino_dancers.mp4",
        "decor_vp": "latino_dancers.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "latino_dancers2": {
        "id": "latino_dancers2",
        "icon": "latino_dancers2_icon.png",
        "decor_tv": "latino_dancers2.mp4",
        "decor_vp": "latino_dancers2.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "mirrorball_fast": {
        "id": "mirrorball_fast",
        "icon": "mirrorball_fast_icon.png",
        "decor_tv": "mirrorball_fast.mp4",
        "decor_vp": "mirrorball_fast.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "mirrorball_interior": {
        "id": "mirrorball_interior",
        "icon": "mirrorball_interior_icon.png",
        "decor_tv": "mirrorball_interior.mp4",
        "decor_vp": "mirrorball_interior.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "mirrorball_slow": {
        "id": "mirrorball_slow",
        "icon": "mirrorball_slow_icon.png",
        "decor_tv": "mirrorball_slow.mp4",
        "decor_vp": "mirrorball_slow.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "moon": {
        "id": "moon",
        "icon": "moon_icon.png",
        "decor_tv": "moon.mp4",
        "decor_vp": "moon.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "moon_dancer": {
        "id": "moon_dancer",
        "icon": "moon_dancer_icon.png",
        "decor_tv": "moon_dancer.mp4",
        "decor_vp": "moon_dancer.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "motorbike": {
        "id": "motorbike",
        "icon": "motorbike_icon.png",
        "decor_tv": "motorbike.mp4",
        "decor_vp": "motorbike.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "mountain_lake_sunset": {
        "id": "mountain_lake_sunset",
        "icon": "mountain_lake_sunset_icon.png",
        "decor_tv": "mountain_lake_sunset.mp4",
        "decor_vp": "mountain_lake_sunset.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "neon_carpet_full": {
        "id": "neon_carpet_full",
        "icon": "neon_carpet_full_icon.png",
        "decor_tv": "neon_carpet_full.mp4",
        "decor_vp": "neon_carpet_full.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "neon_carpet_waves": {
        "id": "neon_carpet_waves",
        "icon": "neon_carpet_waves_icon.png",
        "decor_tv": "neon_carpet_waves.mp4",
        "decor_vp": "neon_carpet_waves.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "neon_circles": {
        "id": "neon_circles",
        "icon": "neon_circles_icon.png",
        "decor_tv": "neon_circles.mp4",
        "decor_vp": "neon_circles.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "neon_dancers": {
        "id": "neon_dancers",
        "icon": "neon_dancers_icon.png",
        "decor_tv": "neon_dancers.mp4",
        "decor_vp": "neon_dancers.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "neon_lines": {
        "id": "neon_lines",
        "icon": "neon_lines_icon.png",
        "decor_tv": "neon_lines.mp4",
        "decor_vp": "neon_lines.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "neon_tunnel_slow": {
        "id": "neon_tunnel_slow",
        "icon": "neon_tunnel_slow_icon.png",
        "decor_tv": "neon_tunnel_slow.mp4",
        "decor_vp": "neon_tunnel_slow.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "old_display": {
        "id": "old_display",
        "icon": "old_display_icon.png",
        "decor_tv": "old_display.mp4",
        "decor_vp": "old_display.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "old_movie": {
        "id": "old_movie",
        "icon": "old_movie_icon.png",
        "decor_tv": "old_movie.mp4",
        "decor_vp": "old_movie.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "orange_glow": {
        "id": "orange_glow",
        "icon": "orange_glow_icon.png",
        "decor_tv": "orange_glow.mp4",
        "decor_vp": "orange_glow.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "orange_sunset": {
        "id": "orange_sunset",
        "icon": "orange_sunset_icon.png",
        "decor_tv": "orange_sunset.mp4",
        "decor_vp": "orange_sunset.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "purple_geometric_tunnel": {
        "id": "purple_geometric_tunnel",
        "icon": "purple_geometric_tunnel_icon.png",
        "decor_tv": "purple_geometric_tunnel.mp4",
        "decor_vp": "purple_geometric_tunnel.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "purple_rnb_dancers": {
        "id": "purple_rnb_dancers",
        "icon": "purple_rnb_dancers_icon.png",
        "decor_tv": "purple_rnb_dancers.mp4",
        "decor_vp": "purple_rnb_dancers.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "purple_sparkles": {
        "id": "purple_sparkles",
        "icon": "purple_sparkles_icon.png",
        "decor_tv": "purple_sparkles.mp4",
        "decor_vp": "purple_sparkles.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "red_blue_lasers": {
        "id": "red_blue_lasers",
        "icon": "red_blue_lasers_icon.png",
        "decor_tv": "red_blue_lasers.mp4",
        "decor_vp": "red_blue_lasers.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "red_blue_vinyl": {
        "id": "red_blue_vinyl",
        "icon": "red_blue_vinyl_icon.png",
        "decor_tv": "red_blue_vinyl.mp4",
        "decor_vp": "red_blue_vinyl.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "reggae_vinyl": {
        "id": "reggae_vinyl",
        "icon": "reggae_vinyl_icon.png",
        "decor_tv": "reggae_vinyl.mp4",
        "decor_vp": "reggae_vinyl.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "route_66": {
        "id": "route_66",
        "icon": "route_66_icon.png",
        "decor_tv": "route_66.mp4",
        "decor_vp": "route_66.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "skate_park": {
        "id": "skate_park",
        "icon": "skate_park_icon.png",
        "decor_tv": "skate_park.mp4",
        "decor_vp": "skate_park.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "smoke": {
        "id": "smoke",
        "icon": "smoke_icon.png",
        "decor_tv": "smoke.mp4",
        "decor_vp": "smoke.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "snow": {
        "id": "snow",
        "icon": "snow_icon.png",
        "decor_tv": "snow.mp4",
        "decor_vp": "snow.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "speakers": {
        "id": "speakers",
        "icon": "speakers_icon.png",
        "decor_tv": "speakers.mp4",
        "decor_vp": "speakers.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "stage_lights1": {
        "id": "stage_lights1",
        "icon": "stage_lights1_icon.png",
        "decor_tv": "stage_lights1.mp4",
        "decor_vp": "stage_lights1.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "stage_lights2": {
        "id": "stage_lights2",
        "icon": "stage_lights2_icon.png",
        "decor_tv": "stage_lights2.mp4",
        "decor_vp": "stage_lights2.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "stage_lights3": {
        "id": "stage_lights3",
        "icon": "stage_lights3_icon.png",
        "decor_tv": "stage_lights3.mp4",
        "decor_vp": "stage_lights3.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "stars_journey": {
        "id": "stars_journey",
        "icon": "stars_journey_icon.png",
        "decor_tv": "stars_journey.mp4",
        "decor_vp": "stars_journey.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "storm": {
        "id": "storm",
        "icon": "storm_icon.png",
        "decor_tv": "storm.mp4",
        "decor_vp": "storm.mp4",
        "filter_tv": "",
        "filter_vp": ""
    },
    "vinyl": {
        "id": "vinyl",
        "icon": "vinyl_icon.png",
        "decor_tv": "vinyl.mp4",
        "decor_vp": "vinyl.mp4",
        "filter_tv": "",
        "filter_vp": ""
    }
}

export default Atmospheres
